import React,{useContext,useEffect, useState, useRef,useReducer, useMemo} from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest } from '../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon,DeleteIcon, PrintIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon} from "../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import { InfinitySpin } from  'react-loader-spinner';
import AuthContext from '../../components/AuthContext';
import UtilContext from '../../components/UtilContext';
import { LocaleContext } from '../../components/LocaleContext';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { createArrayNavigateHandlers } from '../../utils/arrayNavigate';
import { showExcludedMachinesInLists } from '../../utils/moduleSettings';

export default function MachineAdd({machine, type}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const machinesListUrl = `/api/machines?show_excluded_machines=${showExcludedMachinesInLists(state.module_settings) ? '1' : '0'}`;
    const {user} = useContext(AuthContext);
    const {toast,openFavoriteDialog,setFastView,setDialogText,setVisible} = useContext(UtilContext);
    const { t } = useContext(LocaleContext);
    const [closeTab,setCloseTab] = useState(false);

    const submitRef = useRef(null);

    const [formMachine,setFormMachine] = useState(machine);
    const [formType, setFormType] = useState(type);

    //TODO dorobit contractor id
    const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("add maintenance"))?false:true);
    const [scrollIcons,setScrollIcons] = useState((user.permissions?.includes("edit maintenance"))?false:true);


    function addNewMachine(){
        dispatch({type:'create_new_tab',name: t('MachineList.Tab.New'), translationKey: 'MachineList.Tab.New', legacyLabel: t('MachineList.Tab.New'),page:'MachineAdd',props:{machine: null,type:'add'},mask:'gset014'})
    }

    function copyMachine(){
        dispatch({type:'create_new_tab',name: t('MachineList.Tab.New'), translationKey: 'MachineList.Tab.New', legacyLabel: t('MachineList.Tab.New'),page:'MachineAdd',props:{machine: { ...formik.values, id: undefined },type:'add'},mask:'gset014'})
    }

    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = t('Common.RequiredField');
        }*/
        if(values.activity === "Vyradený" && !values.deactivation_date){
            errors.deactivation_date = t('Common.RequiredField');
        }
        return errors;
    };

    const initialValuesForEdit = formMachine && typeof formMachine === 'object'
        ? {
            ...formMachine,
            machine_type_id: formMachine.machine_type_id ?? formMachine.machine_type?.id ?? '',
            last_overhaul: formMachine.last_overhaul ? (formMachine.last_overhaul.split?.('T')?.[0] ?? formMachine.last_overhaul) : '',
            deactivation_date: formMachine.deactivation_date ? (formMachine.deactivation_date.split?.('T')?.[0] ?? formMachine.deactivation_date) : '',
          }
        : null;

    const formik = useFormik({
        initialValues: initialValuesForEdit ?? {
            name: '',machine_type_id:'',type:'',serial_number:'',fabrication_year:'',last_overhaul:'',deactivation_date: '',
            description:'',manufacturer:'',manufacturer_address:'',manufacturer_tel_number:'',manufacturer_fax:'',manufacturer_email:'',manufacturer_web:'',activity:'Aktívny',
        },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            setDialogText(t('Common.Saving'));
            setVisible(true);
            let formData = new FormData();
            const keysToSend = ['name','machine_type_id','type','serial_number','fabrication_year','last_overhaul','deactivation_date','description','manufacturer','manufacturer_address','manufacturer_tel_number','manufacturer_fax','manufacturer_email','manufacturer_web','activity'];
            keysToSend.forEach((key) => {
                const v = values[key];
                formData.append(key, v != null && typeof v !== 'object' ? String(v) : "");
            });
            if(formType=="add"){
                postRequest('/api/machines', formData,true)
                .then((response_first) => {
                    console.log(response_first);
                    getRequest(machinesListUrl).then((response) => {
                        dispatch({type:'load_machines',newMachines:response.data});
                        if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        if(response.data.length-1>=0)formik.setValues(response.data[response.data.length-1]);
                        setFormType("edit");
                        setVisible(false);
                        toast?.current?.show({ severity: 'info', summary: t('MachineList.Toast.DeletedSummary'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                    });
                }).catch((reason) => {
                    setVisible(false);
                    if(!navigator.online){
                        alert(t('ServiceTask.OfflineQueuedAlert'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                })
            }
            else{
                postRequest(`/api/machines/update/${formik.values.id}`, formData,true)
                .then((response) => {
                    getRequest(machinesListUrl).then((response) => {
                        dispatch({type:'load_machines',newMachines:response.data});
                        if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        formik.setValues(values);
                        setVisible(false);
                        toast?.current?.show({ severity: 'info', summary: t('MachineList.Toast.DeletedSummary'), life: 3000, detail: t('Common.Toast.RecordUpdatedDetail') });
                    });
                }).catch((reason) => {
                    setVisible(false);
                    if(!navigator.online){
                        alert(t('ServiceTask.OfflineQueuedAlert'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                })
            }
        },
    });

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(
        () => createArrayNavigateHandlers(state.machines, formik.values.id, setFormMachine),
        [state.machines, formik.values.id]
    );

    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {setCloseTab(true);submitRef.current.click();}}><SaveAndCloseIcon/></button></div>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {submitRef.current.click();}}><SaveIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewMachine()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => copyMachine()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => openFavoriteDialog(t('MachineList.Tab.New'),"MachineAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => setFastView("MachineAdd")}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon/></div>
        </div>
        <form onSubmit={formik.handleSubmit}>
        <div className="relative flex flex-col min-h-[calc(100vh-177px)] overflow-x">
          <div className='xl:grid grid-cols-2 gap-1 mb-2 '>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">
                   {t('MachineAdd.Title')}
                </h1>
                {formType=="edit" && <label className="block text-md font-semibold text-gray-800">{t('Common.RecordIdLabel')}: {formik.values.id}</label>}
                      <div>
                        <label
                            htmlFor="name"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('MachineAdd.Label.MachineName')}
                        </label>
                        <input
                            name='name' required
                            type="text"
                            onChange={formik.handleChange} value={formik.values.name}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="machine_type_id"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('MachineAdd.Label.MachineKind')}
                        </label>
                            <select required
                            name='machine_type_id'
                            onChange={formik.handleChange} value={formik.values.machine_type_id}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                            <option value="">{t('MachineAdd.SelectMachineType')}</option>
                            {state.machine_types.map((machine_type) => (
                            <option key={machine_type.id} value={machine_type.id}>{machine_type.name}</option>
                          ))}
                            </select>
                        </div>
                      <div>
                        <label
                            htmlFor="type"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('MachineAdd.Label.MachineSubtype')}
                        </label>
                        <input
                            name='type' required
                            type="text"
                            onChange={formik.handleChange} value={formik.values.type}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="serial_number"
                            className="block text-md font-semibold text-gray-800 mt-2"
                        >
                            {t('MachineAdd.Label.SerialNumber')}
                        </label>
                        <input
                            name='serial_number' required
                            type="text"
                            onChange={formik.handleChange} value={formik.values.serial_number}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="fabrication_year"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('MachineAdd.Label.FabricationYear')}
                        </label>
                        <input
                            name='fabrication_year' required
                            type="number"
                            onChange={formik.handleChange} value={formik.values.fabrication_year}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="last_overhaul"
                            className="block text-md font-semibold text-gray-800"
                        >
                             {t('MachineAdd.Label.LastOverhaul')}
                        </label>
                        <input 
                            name='last_overhaul'
                            type="date"
                            onChange={formik.handleChange} value={formik.values.last_overhaul}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >
                            {t('MachineAdd.Label.MachineDescription')}
                        </label>
                        <textarea
                        name='description'
                        onChange={formik.handleChange} value={formik.values.description}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>            
            </div>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <div>
                    <label
                        htmlFor="manufacturer"
                        className="block text-md font-semibold text-gray-800 mt-2"
                    >
                        {t('MachineAdd.Label.Manufacturer')}
                    </label>
                    <input
                        name='manufacturer' required
                        type="text"
                        onChange={formik.handleChange} value={formik.values.manufacturer}
                        className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    />
                </div>
                <div>
                    <label
                        htmlFor="manufacturer_address"
                        className="block text-md font-semibold text-gray-800 mt-2"
                    >
                        {t('MachineAdd.Label.ManufacturerAddress')}
                    </label>
                    <input
                        name='manufacturer_address'
                        type="text"
                        onChange={formik.handleChange} value={formik.values.manufacturer_address}
                        className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    />
                </div>
                <div>
                    <label
                        htmlFor="manufacturer_tel_number"
                        className="block text-md font-semibold text-gray-800 mt-2"
                    >
                        {t('MachineAdd.Label.ManufacturerTel')}
                    </label>
                    <input
                        name='manufacturer_tel_number'
                        type="text"
                        onChange={formik.handleChange} value={formik.values.manufacturer_tel_number}
                        className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    />
                </div>
                <div>
                    <label
                        htmlFor="manufacturer_fax"
                        className="block text-md font-semibold text-gray-800 mt-2"
                    >
                        {t('MachineAdd.Label.ManufacturerFax')}
                    </label>
                    <input
                        name='manufacturer_fax'
                        type="text"
                        onChange={formik.handleChange} value={formik.values.manufacturer_fax}
                        className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    />
                </div>
                <div>
                    <label
                        htmlFor="manufacturer_email"
                        className="block text-md font-semibold text-gray-800 mt-2"
                    >
                        {t('MachineAdd.Label.ManufacturerEmail')}
                    </label>
                    <input
                        name='manufacturer_email'
                        type="email"
                        onChange={formik.handleChange} value={formik.values.manufacturer_email}
                        className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    />
                </div>
                <div>
                    <label
                        htmlFor="manufacturer_web"
                        className="block text-md font-semibold text-gray-800 mt-2"
                    >
                        {t('MachineAdd.Label.ManufacturerWeb')}
                    </label>
                    <input
                        name='manufacturer_web'
                        type="text"
                        onChange={formik.handleChange} value={formik.values.manufacturer_web}
                        className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                    />
                </div>
                <div>
                    <label
                        htmlFor="activity"
                        className="block text-md font-semibold text-gray-800 mt-2"
                    >
                        {t('MachineAdd.Label.Status')}
                    </label>
                    <select 
                        name='activity'
                        onChange={(e) => {
                            formik.handleChange(e);
                            if (e.target.value !== "Vyradený") {
                                formik.setFieldValue("deactivation_date", "");
                            }
                        }}
                        value={formik.values.activity}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                        <option value="Aktívny">{t('MachineAdd.Activity.Active')}</option>
                        <option value="Vyradený">{t('MachineAdd.Activity.Retired')}</option>
                    </select>
                    {formik.values.activity === "Vyradený" && (
                        <div className="mt-2">
                            <label className="block text-md font-semibold text-gray-800">
                            {t('MachineAdd.Label.DeactivationDate')}
                            </label>
                            <input
                            type="date"
                            name="deactivation_date"
                            value={formik.values.deactivation_date}
                            onChange={formik.handleChange}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                            />
                            {formik.errors.deactivation_date && (
                            <div className="mt-1 text-sm text-red-600">{formik.errors.deactivation_date}</div>
                            )}
                        </div>
                    )}
                </div>
                <button type="submit" ref={submitRef} className='hidden'></button>
            </div>
            </div>
            </div>
             </form>            
            </div>
            </> 
            );
} 
